// Het ontwerp uit de webshop-editor (akkoord Martijn 13-10-2026): de gepubliceerde stand van deze webshopwidget, of in de editor
// het concept. null = geen ontwerp: de webshop ziet eruit zoals altijd. Zie lib/webshopOntwerp.js.
import { createSlice } from "@reduxjs/toolkit";
import { normaliseerOntwerp } from "../../lib/webshopOntwerp";

const initialState = {
  ontwerp: null,
  // Laat de widget het concept zien (editor of "Test je webshop")?
  concept: false,
  // Een product dat de editor wil laten bewerken (opent de Productbewerker), of null.
  bewerkProduct: null,
};

const webshopontwerpSlice = createSlice({
  name: "Webshopontwerp",
  initialState,
  reducers: {
    zetOntwerp: (state, action) => {
      state.ontwerp = normaliseerOntwerp(action.payload?.ontwerp ?? action.payload);
      if (typeof action.payload?.concept === "boolean") state.concept = action.payload.concept;
    },
    zetBewerkProduct: (state, action) => {
      state.bewerkProduct = action.payload ?? null;
    },
  },
});

export const { zetOntwerp, zetBewerkProduct } = webshopontwerpSlice.actions;
export default webshopontwerpSlice.reducer;
